import CrudModel from './CrudModel';
import agendaModel from 'models/AgendaModel';
import { mapTaskContactForCrud } from './mapTaskContactForCrud';

export { mapTaskContactForCrud };

export default class TaskModel extends CrudModel {
    constructor(entity) {
        super(entity);
        let endDateISO = this.entity.ffin;
        endDateISO = endDateISO + 'T' + this.entity.hfin;
        let initialDateISO = this.entity.fini;
        initialDateISO = initialDateISO + 'T' + this.entity.hini;

        this.entity = {
            ...this.entity,
            startDateISO: initialDateISO,
            endDateISO: endDateISO,
        };
    }

    static toCrud({ data, mappedSchema }) {
        const { IdContact, idContact, idContacto, ...crudData } = agendaModel.toCrud({
            data,
            mappedSchema,
        });

        return {
            ...crudData,
            contact: mapTaskContactForCrud(data),
        };
    }
    static toSave(data) {
        const idContacto = data?.idContacto ?? data?.contact?.value ?? data?.contact ?? '-1';
        const finalData = agendaModel.toSave({ ...data, idContacto });

        delete finalData.Attendees;
        delete finalData.IdContact;
        finalData.idContacto = idContacto;

        return finalData;
    }
    static toList(props) {
        return agendaModel.toList(props);
    }
    static toCrudFromCopilot(data) {
        return agendaModel.toCrudFromCopilot(data);
    }
}
